import { render, staticRenderFns } from "./SignUp.pug?vue&type=template&id=04548642&scoped=true&lang=pug&"
import script from "./SignUp.js?vue&type=script&lang=js&"
export * from "./SignUp.js?vue&type=script&lang=js&"
import style0 from "./SignUp.sass?vue&type=style&index=0&id=04548642&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04548642",
  null
  
)

component.options.__file = "SignUp.vue"
export default component.exports